// statuses from the backend
export const ACTIVE = 'active';
export const DEACTIVATED = 'deactivated';
export const DECLINED = 'declined';
export const PENDING = 'pending';

// status display labels on the frontend
export const APPEAR_ONLINE = 'Appear Online';
export const APPEAR_OFFLINE = 'Appear Offline';
export const INVITE_ACCEPTED = 'Invite Accepted';
export const INVITE_ACCEPTED_OFFLINE = 'Invite Accepted (appearing offline)';
export const INVITE_DECLINED = 'Invite Declined';
export const INVITE_PENDING = 'Invite Pending';
